import { apiGet } from '../../api'

export const get_configurations = () => {
  return apiGet({
    endpoint: 'recruitment/get_configurations'
  })
}
